import React from 'react'
import TableContent from '../../components/TableContent'
const url = 'logs'
const item = 'Log'
const items = 'Logs'

const Log = () => {
  return (
    <TableContent
      url={url}
      type={'log'}
      item={item}
      items={items}
    />
  )
}
export default Log
